import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { PageWrapper } from "components/Containers";
import BookAMeeting from "components/BookAMeeting";
/**
 * BookMeeting
 */
const BookMeeting = () => {
  const intl = useIntl();

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Client.BooKMeeting.Title" })}</title>
      </Helmet>
      <BookAMeeting />
    </PageWrapper>
  );
};

export default BookMeeting;
